import Navbar from "./components/Navbar";
import HeroBanner from "./components/HeroBanner";
import FeaturedOffers from "./components/FeaturedOffers";
import LatestProducts from "./components/LatestProducts";
// import PcBuilderTeaser from "./components/PcBuilderTeaser";
import FAQSection from "./components/FAQSection";
import MapSection from "./components/MapSection";
import ContactSection from "./components/ContactSection";
import SiteFooter from "./components/SiteFooter";
import SEOHead from "../../components/base/SEOHead";
import { seoPage } from "../../config/seoPages";
import AnimatedSection from "../../components/base/AnimatedSection";
import AdminPanel from "../../components/feature/AdminPanel";

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'SpartechRD',
  description: 'Tienda especializada en hardware gaming, componentes PC, sillas gaming, monitores y ensamblajes personalizados en Santo Domingo Este, República Dominicana.',
  url: 'https://spartechrd.com',
  telephone: '+1-849-208-1166',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'C/Octavio Mejía Ricart Esq. C/ Aruba #61, Ens. Ozama',
    addressLocality: 'Santo Domingo Este',
    addressRegion: 'Santo Domingo',
    addressCountry: 'DO',
  },
  geo: { '@type': 'GeoCoordinates', latitude: 18.4861, longitude: -69.8775 },
  openingHoursSpecification: [
    { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'], opens: '09:00', closes: '18:00' },
  ],
  sameAs: ['https://www.instagram.com/spartechrd', 'https://www.facebook.com/spartechrd'],
};

export default function HomePage() {
  return (
    <div className="min-h-screen bg-zinc-950 font-sans">
      <SEOHead
        {...seoPage('home')}
        keywords="hardware gaming santo domingo, tienda pc dominicana, spartech, componentes gaming, arma tu pc RD"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroBanner />

        <AnimatedSection variant="fadeUp" delay={0}>
          <FeaturedOffers />
        </AnimatedSection>

        <AnimatedSection variant="fadeUp" delay={0}>
          <LatestProducts />
        </AnimatedSection>

        {/* <AnimatedSection variant="scaleIn" delay={0}>
          <PcBuilderTeaser />
        </AnimatedSection> */}

        <AnimatedSection variant="fadeUp" delay={0}>
          <FAQSection />
        </AnimatedSection>

        <AnimatedSection variant="scaleIn" delay={0}>
          <MapSection />
        </AnimatedSection>

        <AnimatedSection variant="fadeRight" delay={0}>
          <ContactSection />
        </AnimatedSection>
      </main>
      <SiteFooter />
      <AdminPanel />
    </div>
  );
}